import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import pattern from "../../Assets/pattern.svg";
import Image from 'react-bootstrap/Image';

import serviceHeroImage from "../../Assets/service-hero.png";

import { TbUserCheck } from "react-icons/tb";
import { RiFileEditLine } from "react-icons/ri";
import { LuHandshake } from "react-icons/lu";
import { RiExchangeDollarFill } from "react-icons/ri";
import { LuUserSearch } from "react-icons/lu";
import { TbBinaryTree } from "react-icons/tb";
import { LiaUserTieSolid } from "react-icons/lia";
import { GrAnnounce } from "react-icons/gr";

export default function Service() {
    return (
        <div>
            <section className='section-hero'>
                <Container fluid className="header-section">
                    <Row style={{ background: "#1b3f38" }}>
                        <Col md={12} >
                            <div className="padding-section-large text-center d-flex flex-column text-white">
                                <div className="max-width-large mx-auto">
                                    <h1 className="heading-style-h1">Services CeWaves</h1>
                                </div>
                                <div className='pt-2 max-width-medium mx-auto'>
                                    <p className="text-size-medium">Our recruiters partner closely with clients to identify, engage, and retain the right employees</p>
                                </div>
                            </div>
                        </Col>
                        <div className='position-absolute top-0 left-0 w-100 h-100'>
                            <Image src={pattern} />
                        </div>

                    </Row>
                </Container >
            </section >
            <section className="position-relative">
                <div className='p-5 pb-0'>
                    <div className="row align-items-center">
                        <div className="col-md-8 pe-md-5 pb-5" >
                            <h1 className="pb-3">What We Do</h1>
                            <p className="text-size-large pe-md-5">Our professional services continuously evolve to meet the demands of a changing workforce. We are committed to delivering high-quality, value-driven HR and staffing solutions for every client and every open position.</p>
                            <p className="text-size-large pe-md-5">At CeWaves, we offer a comprehensive range of services designed to align with your work culture, timelines, budget, and business objectives. Our approach is collaborative — we work as an extension of your team to ensure the right talent is hired, retained, and enabled for long-term success.</p>
                            <p className="text-size-large pe-md-5">Our recruiters partner closely with clients to identify, engage, and retain the right employees, resulting in lower attrition rates and improved business outcomes.</p>
                        </div>
                        <div className="col-md-4">
                            <Image src={serviceHeroImage} className="img-fluid rounded" />
                        </div>
                    </div>
                </div>
            </section>
            <section className='padding-section-large px-5 bg-black text-white mb-5'>
                <Row className='mb-4'>
                    <h1 className=''>Our Services Include</h1>
                </Row>
                <Row className='mb-5'>
                    <Col className='col-12 col-md-4 pb-md-0 pb-5'>
                        <TbUserCheck className='display-1' />
                        <h3>Permanent Staffing</h3>
                    </Col>
                    <Col className='col-12 col-md-4 pb-md-0 pb-5'>
                        <RiFileEditLine className='display-1' />
                        <h3>Contract Staffing</h3>
                    </Col>
                    <Col className='col-12 col-md-4'>
                        <LuHandshake className='display-1' />
                        <h3>Contract-to-Hire Staffing</h3>
                    </Col>
                </Row>
                <Row className='mb-5'>
                    <Col className='col-12 col-md-4 pb-md-0 pb-5'>
                        <RiExchangeDollarFill className='display-1' />
                        <h3>Payrolling Services / Third-Party Payroll</h3>
                    </Col>
                    <Col className='col-12 col-md-4 pb-md-0 pb-5'>
                        <LuUserSearch className='display-1' />
                        <h3>Hire Employees on Our Payroll</h3>
                    </Col>
                    <Col className='col-12 col-md-4'>
                        <TbBinaryTree className='display-1' />
                        <h3>Recruitment Process Outsourcing (RPO)</h3>
                    </Col>
                </Row>
                <Row>
                    <Col className='col-12 col-md-4 pb-md-0 pb-5'>
                        <LiaUserTieSolid className='display-1' />
                        <h3>HR Outsourcing</h3>
                    </Col>
                    <Col className='col-12 col-md-4 pb-md-0 pb-5'>
                        <RiExchangeDollarFill className='display-1' />
                        <h3>Payroll Outsourcing</h3>
                    </Col>
                    <Col className='col-12 col-md-4'>
                        <GrAnnounce className='display-1' />
                        <h3>Gulf Hiring</h3>
                    </Col>
                </Row>
            </section>
        </div >
    )
}
